import { Breakpoints } from '../types/index.js';
const buildAllBreakpointsWithGivenBreakpoints = props => {
  const breakpointsOrder = Breakpoints;
  return breakpointsOrder.reduce((accumulator, breakpoint, index) => {
    if (typeof props[breakpoint] !== 'undefined') {
      return Object.assign(Object.assign({}, accumulator), {
        [breakpoint]: props[breakpoint]
      });
    } else {
      const pastBreakpoints = breakpointsOrder.slice(0, index).reverse();
      const isFirstBreakpoint = index === 0;
      const pastDefinedBreakpoint = pastBreakpoints.find(bp => props[bp]);
      const pastDefinedValue = pastDefinedBreakpoint ? props[pastDefinedBreakpoint] : undefined;
      const pastBreakpointValue = isFirstBreakpoint ? undefined : pastDefinedValue;
      return Object.assign(Object.assign({}, accumulator), pastBreakpointValue ? {
        [breakpoint]: pastBreakpointValue
      } : {});
    }
  }, {});
};
buildAllBreakpointsWithGivenBreakpoints({
  xs: 'lalaland'
});
export { buildAllBreakpointsWithGivenBreakpoints };